import * as React from 'react';
import * as styled from './styled';
import {LoadedContainerProps} from './types';

/**
 * The container of loaded element.
 * @param {React.PropsWithChildren<LoadedContainerProps>} props
 * @return {React.ReactElement<React.PropsWithChildren<LoadedContainerProps>>}
 * @constructor
 */
export default function LoadedContainer(
    props: React.PropsWithChildren<LoadedContainerProps>,
): React.ReactElement<React.PropsWithChildren<LoadedContainerProps>> {
  /**
   * Render controls.
   * @return {JSX.Element | undefined}
   */
  function renderControls(): JSX.Element | undefined {
    return props.controls ? (
      <styled.Controls>
        {props.controls}
      </styled.Controls>
    ) : undefined;
  }

  return (
    <styled.Wrapper>
      {renderControls()}
      {props.children}
    </styled.Wrapper>
  );
}
